import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box, Fab } from '@mui/material';
import ContentAdd from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import { QRCodeCanvas } from 'qrcode.react';
import Paper from '@mui/material/Paper';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import { DataGrid, type GridColDef, type GridSortModel } from '@mui/x-data-grid';

import { clone, setConfig } from '../../core';
import { bizpost } from '../../ajax';
import { ProgressDialog } from '../../components/dialogs';
import { Data } from '../../components/base';
import { formatDate, formatSource } from '../../components/renderers/formats';
import InspectorDialog from '../custom/InspectorDialog';
import GridToolbar from '../../components/grid/GridToolbar';

const s: any = {};

class Qrcode extends Component<any, any> {
  static propTypes: any;
  static defaultProps: any;

  constructor(props: any) {
    super(props);
    this.state = {
      title: 'qrtokens',
      url: '/biz',
      params: {},
      action: '',
      filter: {},
      loading: false,
      wizmode: 'add',
      record: {},
      data: [],
      recordCount: 0,
      page: 0,
      rowsPerPage: 10,
      pageMode: 'local',
      order: 'desc',
      orderBy: 'stp',
      refid: null,
      fwopen: false,
      sortModel: [{ field: 'stp', sort: 'desc' as const }],
      selected: [],
      selectedRecord: null,
      actions: [],
      cols: [],
    };
  }

  configuration = () => {
    const config = {
      service: {
        name: 'qrtokens',
        title: 'QRCodes',
        key: 'rid',
        num: true,
        fields: ['rid', 'tok', 'pur', 'exp', 'usd', 'exi', 'sts', 'ast', 'stp', 'sri', 'sna', 'ssh'],
        params: { tok: 'Token', pur: 'Purpose', sri: 'Service', sts: 'Status' },
        grid: [
          ['tok', 'Token'],
          ['qrp', 'QR'],
          ['pur', 'Purpose'],
          ['sna', 'Service'],
          ['exp', 'Expires At'],
          // ['usd', 'Used At'],
          ['ast', 'Status'],
          ['stp', 'Stamp'],
        ],
        bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
        menu: { mnu: [{ t: 'Token', v: 'tok' }, { t: 'Purpose', v: 'pur' }], def: 'tok' },
        eform: [
          { id: 'tok', label: 'QR Token', type: 'ai', req: 1, ops: {} },
          { id: 'sri', label: 'Mass / Church Service', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'services' } },
          { id: 'pur', label: 'Purpose', type: 'fa', req: 1, ops: {}, cp: { t: 'lcs', s: 'qrcodepurpose' } },
          { id: 'exp', label: 'Expires On', type: 'df', req: 1, ops: {} },
          { id: 'exi', label: 'Extra Info', type: 'jf', req: 0, ops: {} },
          { id: 'sts', label: 'Record Status', type: 'fa', req: 0, ops: {}, cp: { t: 'lcs', s: 'status' } },
        ],
      },
      create: true,
      actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete', view: 'View' },
      panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' },
      formatters: {
        grid: {
          exi: (value: any) => (value ? JSON.stringify(value) : ''),
          qrp: (_: any, rec: any) =>
            rec?.tok ? <QRCodeCanvas value={String(rec.tok)} size={48} includeMargin={false} /> : '',
        },
      },
    };
    return config;
  };

  getServiceConfig = () => {
    const extraconfig = Object.assign({}, this.configuration());
    const config = setConfig(extraconfig);
    const ServiceConfig = clone(config);
    const SData = ServiceConfig.service;
    return { svc: ServiceConfig, svd: SData };
  };

  setPageMode = () => {
    const { svd } = this.getServiceConfig();
    const { pageMode = 'local' } = svd;
    this.setState({ pageMode });
  };

  componentDidMount() {
    this.setPageMode();
    this.refresh();
  }

  refresh = async (inparams?: any) => {
    try {
      const { svd } = this.getServiceConfig();
      const { pageMode = 'local' } = svd;
      const { params, rowsPerPage, page } = this.state;

      this.startLoading();
      const pos = page * rowsPerPage;
      const plm = rowsPerPage;
      const paging = pageMode === 'remote' ? { pos, plm } : {};
      const extraparams = inparams || params;
      const baseparams = {
        s: 'qrtokens',
        a: 'find',
        ...extraparams,
        ...paging,
      };
      const response = await bizpost(baseparams);
      this.setState({ data: response.sd, recordCount: +response.rc });
    } catch (error) {
      this.setState({ data: [], recordCount: 0 });
      const errorx: any = error || {};
      this.props.showNotification(
        errorx.message || 'request failed',
        errorx.type || 'warn',
        errorx.title || 'Loading Error'
      );
    } finally {
      if (this.state.loading) this.stopLoading();
    }
  };

  startLoading = () => {
    this.setState({ loading: true });
  };

  onSearch = async (_service: string, query: string) => {
    try {
      const { params } = this.state;
      this.startLoading();
      const extraparams = { qry: query, ...params };
      const baseparams = {
        s: 'qrtokens',
        a: 'find',
        tok: query,
        ...extraparams,
      };
      const response = await bizpost(baseparams);
      this.setState({ data: response.sd, recordCount: +response.rc });
    } catch (error) {
      this.setState({ data: [], recordCount: 0 });
      const errorx: any = error || {};
      this.props.showNotification(
        errorx.message || 'request failed',
        errorx.type || 'warn',
        errorx.title || 'Loading Error'
      );
    } finally {
      if (this.state.loading) this.stopLoading();
    }
  };

  stopLoading = () => {
    this.setState({ loading: false });
  };

  handleRecord = (record: any) => () => {
    const actions = this.props.actionSet || {};
    const { url } = this.state;
    const action = actions[record.action] || Data.actions[record.action] || 'Process';
    const { handleRecord } = this.props;
    const xrecord = typeof handleRecord === 'function' ? handleRecord(record) : record;
    if (xrecord) {
      this.setState({
        record: xrecord.item,
        wizmode: xrecord.action,
        action,
        url: xrecord.url || url,
        fwopen: true,
      });
    }
  };

  handleDelete = (record: any) => () => {
    this.setState({ record, wizmode: 'delete', fwopen: true });
  };

  handleClose = () => {
    this.setState({ fwopen: false });
  };

  showPurpose = (value: any) => {
    if (value === 'church-service') return 'Church Service';
    if (value === 'mass') return 'Mass';
    return value || 'N/A';
  };

  showDate = (value: any) => {
    if (!value) return 'N/A';
    return formatDate(value);
  };

  showText = (value: any) => {
    if (value === null || value === undefined || value === '') return 'N/A';
    return String(value);
  };

  escapeHtml = (value: any) => {
    const text = this.showText(value);
    return text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  openPdfWindow = (record: any) => {
    const qrCanvas = document.getElementById('qrcode-view-canvas') as HTMLCanvasElement | null;
    const qrImage = qrCanvas ? qrCanvas.toDataURL('image/png') : '';
    const win = window.open('', '_blank', 'noopener,noreferrer,width=960,height=720');
    if (!win) return null;

    const html = `
      <!doctype html>
      <html>
      <head>
        <meta charset="utf-8" />
        <title>QR Code - ${this.escapeHtml(record?.tok)}</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 24px; color: #1f2937; }
          .card { border: 1px solid #e5e7eb; border-radius: 8px; padding: 18px; }
          .head { display: flex; justify-content: space-between; align-items: center; margin-bottom: 14px; }
          .title { font-size: 20px; font-weight: 700; }
          .grid { display: grid; grid-template-columns: 220px 1fr; gap: 18px; }
          .qrbox { border: 1px solid #e5e7eb; border-radius: 8px; padding: 12px; text-align: center; }
          .tok { margin-top: 10px; word-break: break-all; font-size: 12px; }
          .row { display: grid; grid-template-columns: 160px 1fr; gap: 8px; margin: 6px 0; }
          .key { color: #6b7280; font-size: 12px; text-transform: uppercase; letter-spacing: .04em; }
          .val { font-size: 14px; }
          .exi { white-space: pre-wrap; font-family: monospace; font-size: 12px; border: 1px solid #e5e7eb; border-radius: 6px; padding: 10px; background: #fafafa; }
        </style>
      </head>
      <body>
        <div class="card">
          <div class="head">
            <div class="title">QR Code Details</div>
            <div>${new Date().toLocaleString()}</div>
          </div>
          <div class="grid">
            <div class="qrbox">
              ${qrImage ? `<img src="${qrImage}" alt="QR Code" width="170" height="170" />` : ''}
              <div class="tok">${this.escapeHtml(record?.tok)}</div>
            </div>
            <div>
              <div class="row"><div class="key">Purpose</div><div class="val">${this.escapeHtml(this.showPurpose(record?.pur))}</div></div>
              <div class="row"><div class="key">Status</div><div class="val">${this.escapeHtml(this.formatStatus('view')(record?.sts))}</div></div>
              <div class="row"><div class="key">Service</div><div class="val">${this.escapeHtml(record?.sna)}</div></div>
              <div class="row"><div class="key">Short Code</div><div class="val">${this.escapeHtml(record?.ssh)}</div></div>
              <div class="row"><div class="key">Service ID</div><div class="val">${this.escapeHtml(record?.sri)}</div></div>
              <div class="row"><div class="key">Record ID</div><div class="val">${this.escapeHtml(record?.rid)}</div></div>
              <div class="row"><div class="key">Expires At</div><div class="val">${this.escapeHtml(this.showDate(record?.exp))}</div></div>
              <div class="row"><div class="key">Used At</div><div class="val">${this.escapeHtml(this.showDate(record?.usd))}</div></div>
              <div class="row"><div class="key">Updated</div><div class="val">${this.escapeHtml(this.showDate(record?.stp))}</div></div>
              <div class="row"><div class="key">Extra Info</div><div class="val exi">${this.escapeHtml(record?.exi ? JSON.stringify(record.exi, null, 2) : 'N/A')}</div></div>
            </div>
          </div>
        </div>
      </body>
      </html>
    `;

    win.document.open();
    win.document.write(html);
    win.document.close();
    return win;
  };

  onPrintPdf = () => {
    const { record } = this.state;
    const win = this.openPdfWindow(record);
    if (win) {
      win.focus();
      setTimeout(() => win.print(), 200);
    }
  };

  onDownloadPdf = () => {
    const { record } = this.state;
    const win = this.openPdfWindow(record);
    if (win) {
      win.focus();
      // Browser print dialog allows "Save as PDF".
      setTimeout(() => win.print(), 200);
    }
  };

  renderViewDialog = () => {
    const { fwopen, wizmode, record } = this.state;
    if (!(fwopen && wizmode === 'view')) return null;

    return (
      <Dialog open={fwopen} onClose={this.handleClose} maxWidth="md" fullWidth>
        <DialogTitle sx={{ pb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="h6">QR Code Details</Typography>
            <IconButton onClick={this.handleClose} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '260px 1fr' }, gap: 3 }}>
            <Box sx={{ p: 2, borderRadius: 2, border: '1px solid #e6e6e6', textAlign: 'center' }}>
              <QRCodeCanvas id="qrcode-view-canvas" value={String(record?.tok || '')} size={190} includeMargin />
              <Typography variant="body2" sx={{ mt: 2, wordBreak: 'break-all' }}>
                {this.showText(record?.tok)}
              </Typography>
              <Box sx={{ mt: 2, display: 'flex', gap: 1, justifyContent: 'center', flexWrap: 'wrap' }}>
                <Chip label={`Status: ${this.formatStatus('view')(record?.sts)}`} color="primary" variant="outlined" />
                <Chip label={`Purpose: ${this.showPurpose(record?.pur)}`} color="secondary" variant="outlined" />
              </Box>
            </Box>
            <Box>
              <Typography variant="subtitle2" color="text.secondary">
                Service Information
              </Typography>
              <Box sx={{ mt: 1, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1.5 }}>
                <Box><Typography variant="caption" color="text.secondary">Service Name</Typography><Typography>{this.showText(record?.sna)}</Typography></Box>
                <Box><Typography variant="caption" color="text.secondary">Short Code</Typography><Typography>{this.showText(record?.ssh)}</Typography></Box>
                <Box><Typography variant="caption" color="text.secondary">Service ID</Typography><Typography>{this.showText(record?.sri)}</Typography></Box>
                <Box><Typography variant="caption" color="text.secondary">Record ID</Typography><Typography>{this.showText(record?.rid)}</Typography></Box>
              </Box>
              <Divider sx={{ my: 2 }} />
              <Typography variant="subtitle2" color="text.secondary">
                Token Lifecycle
              </Typography>
              <Box sx={{ mt: 1, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1.5 }}>
                <Box><Typography variant="caption" color="text.secondary">Expires At</Typography><Typography>{this.showDate(record?.exp)}</Typography></Box>
                <Box><Typography variant="caption" color="text.secondary">Used At</Typography><Typography>{this.showDate(record?.usd)}</Typography></Box>
                <Box><Typography variant="caption" color="text.secondary">Updated</Typography><Typography>{this.showDate(record?.stp)}</Typography></Box>
                <Box><Typography variant="caption" color="text.secondary">A-Status</Typography><Typography>{this.showText(record?.ast)}</Typography></Box>
              </Box>
              <Divider sx={{ my: 2 }} />
              <Typography variant="subtitle2" color="text.secondary">
                Extra Info
              </Typography>
              <Box
                sx={{
                  mt: 1,
                  p: 1.5,
                  borderRadius: 1,
                  border: '1px solid #ececec',
                  bgcolor: '#fafafa',
                  fontFamily: 'monospace',
                  fontSize: 13,
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                }}
              >
                {record?.exi ? JSON.stringify(record.exi, null, 2) : 'N/A'}
              </Box>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.onDownloadPdf} variant="outlined">
            Download PDF
          </Button>
          <Button onClick={this.onPrintPdf} variant="outlined">
            Print PDF
          </Button>
          <Button onClick={this.handleClose} variant="contained">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  onResponse = (status: any, _response: any) => {
    if (status) {
      this.handleClose();
      this.refresh();
    }
  };

  formatStatus = (_type: string) => (id: any) => {
    const statuses: any = {
      0: 'disabled',
      1: 'active',
      2: 'used',
      3: 'expired',
    };
    return statuses[id] || 'unknown';
  };

  rowActions = (_id: any, rec: any) => {
    if (rec.usd) return ['view'];
    if ([0, 1].includes(rec.sts)) return ['view', 'edit', 'delete'];
    return ['view'];
  };

  onPageChange = (_event: any, page: any) => {
    this.setState({ page });
  };

  onRowsPerPageChange = (event: any) => {
    this.setState({ rowsPerPage: event.target.value });
  };

  filterColumns = (rows: any[]) => {
    const { cols } = this.state;
    const colids: any[] = Array.isArray(cols) && cols.length > 0 ? cols : rows.map((row: any) => row.id);
    return rows.filter((row: any) => colids.includes(row.id));
  };

  setColumns = (_event: any, fcols: any) => {
    this.setState({ cols: fcols });
  };

  onSortModelChange = (sortModel: GridSortModel) => {
    this.setState({ sortModel });
  };

  onRowSelect = (_event: any, row: any) => {
    const { data } = this.state;
    const selected = data?.find((d: any) => d.rid === row?.rid);
    if (selected && selected.rid !== undefined) {
      const item = data?.find((d: any) => d.rid === selected.rid);
      const gridactions = this.rowActions(row?.id, item);
      this.setState({
        selected: [selected?.rid],
        selectedRecord: item,
        actions: gridactions,
      });
    }
  };

  render() {
    const { code, showNotification } = this.props;
    const {
      url,
      action,
      loading,
      wizmode,
      fwopen,
      record,
      data,
      recordCount,
      page,
      rowsPerPage,
      order,
      orderBy,
      sortModel,
      selected,
      selectedRecord,
      actions,
      cols,
    } = this.state;
    const cancreate = true;
    const fabstyle = { position: 'fixed', right: 20, bottom: 20 };
    const isform = action !== '';
    const stitle = 'Qr Codes';
    const extraconfig = Object.assign({}, this.configuration());
    const config = setConfig(extraconfig);
    const ServiceConfig = clone(config);
    const SData = ServiceConfig.service;
    if (!SData) this.props.setHome();

    const cm = SData.cols;
    const fmformatters = {
      sts: this.formatStatus('form'),
      exp: formatDate,
      usd: formatDate,
      stp: formatDate,
      src: formatSource,
    };
    const gdformatters = {
      sts: this.formatStatus('grid'),
      exp: formatDate,
      usd: formatDate,
      stp: formatDate,
      src: formatSource,
    };

    const cformatters = ServiceConfig.formatters || {};
    const { form: cfformatters, grid: cgformatters } = cformatters;
    const _formformatters = Object.assign({}, fmformatters, cfformatters, {});
    const _gridformatters = Object.assign({}, gdformatters, cgformatters, {});
    const _rowActions = this.rowActions;

    const newrecord = { item: { sts: 1, pur: 'mass', exi: {}, a: 'add' }, action: 'add' };
    const { pageMode = 'local' } = SData;
    const panels = ServiceConfig.panels;
    const isRemote = pageMode === 'remote';
    const rowCount = isRemote ? recordCount : data?.length || 0;
    const frows = this.filterColumns(cm);
    const columns: GridColDef[] = frows.map((col: any) => ({
      field: col.id,
      headerName: col.label || col.id,
      width: col.width || 120,
      sortable: true,
      align: col.numeric ? 'right' : 'left',
      headerAlign: col.numeric ? 'right' : 'left',
      renderCell: (params: any) => {
        const value = params.value;
        const row = params.row;
        return _gridformatters[col.id]
          ? _gridformatters[col.id](value, row)
          : value !== null && value !== undefined
          ? String(value)
          : '';
      },
    }));

    return (
      <Box>
        {cancreate && (
          <Fab
            color="secondary"
            sx={{
              ...s.fixedfab,
              ...fabstyle,
            }}
            onClick={this.handleRecord(newrecord)}
          >
            <ContentAdd sx={{ ...s.actionfab }} />
          </Fab>
        )}
        {isform && fwopen && wizmode !== 'view' && (
          <InspectorDialog
            open={fwopen}
            mode={wizmode}
            code={code}
            title={`${action} ${stitle}`}
            service="qrtokens"
            url={url}
            panels={panels}
            actions={_rowActions}
            actionSet={this.props.actionSet}
            rowActions={this.props.rowActions}
            record={record}
            data={data}
            sdata={SData}
            sconfig={ServiceConfig}
            formatters={_formformatters}
            onChange={this.props.onChange}
            refresh={this.refresh}
            onSubmit={this.props.onSubmit}
            onResponse={this.onResponse}
            onClose={this.handleClose.bind(this)}
            showNotification={showNotification}
          />
        )}
        {this.renderViewDialog()}
        {loading && (
          <ProgressDialog
            open={loading}
            loading={loading}
            startLoading={this.startLoading}
            stopLoading={this.stopLoading}
          />
        )}
        {!fwopen && (
          <Paper sx={{ width: '100%' }}>
            <GridToolbar
              title={stitle}
              sdata={SData}
              actions={actions}
              numSelected={selected.length}
              selectedRecord={selectedRecord}
              setColumns={this.setColumns}
              cols={cm}
              fcols={frows}
              handleSelect={this.handleRecord.bind(this)}
              onAction={this.handleRecord.bind(this)}
              refresh={() => this.refresh()}
            />
            <Box sx={{ width: '100%', height: 600 }}>
              <DataGrid
                rows={data || []}
                columns={columns}
                getRowId={(row) => {
                  if (row.id !== undefined && row.id !== null) return row.id;
                  if (row.rid !== undefined && row.rid !== null) return row.rid;
                  const index = (data || []).indexOf(row);
                  return index >= 0 ? `row-${index}` : `row-${Math.random()}`;
                }}
                rowCount={rowCount}
                paginationModel={{ page, pageSize: rowsPerPage }}
                pageSizeOptions={[5, 10, 25, 50, 100]}
                paginationMode={isRemote ? 'server' : 'client'}
                sortingMode={isRemote ? 'server' : 'client'}
                sortModel={sortModel}
                onSortModelChange={this.onSortModelChange}
                onPaginationModelChange={(model) => {
                  this.onPageChange(null, model.page);
                  if (model.pageSize !== rowsPerPage) this.onRowsPerPageChange({ target: { value: model.pageSize } });
                }}
                onRowClick={(e) => this.onRowSelect(e, e.row)}
                checkboxSelection
                disableMultipleRowSelection
                disableRowSelectionOnClick={false}
                hideFooterSelectedRowCount
              />
            </Box>
          </Paper>
        )}
      </Box>
    );
  }
}

Qrcode.propTypes = {
  service: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  setPage: PropTypes.func,
  setHome: PropTypes.func,
  showNotification: PropTypes.func,
};

export default Qrcode;
